// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JyP3zzcnlgem5nilIvWY{line-height:inherit;margin-left:4px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/ui/MemberLabel/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,eAAA","sourcesContent":[".labelContentEmail {\n  line-height: inherit;\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelContentEmail": `JyP3zzcnlgem5nilIvWY`
};
export default ___CSS_LOADER_EXPORT___;
